export default {
  guest: {
    earn_pts: 'Gana {{points}} pts en este pedido',
    tagline: 'Obtén recompensas. En cada pedido, siempre.',
    pick_reward: 'Elige lo que quieras cuando llegues',
    free_at: 'gratis con {{points}} pts',
    save_at: 'ahorra {{amount}} con {{points}} pts',
    nearest: 'más cercano',
    cta: 'Empieza a ganar — es gratis',
    already_member: '¿Ya eres miembro?',
    sign_in: 'Iniciar sesión',
  },
  member: {
    earning_free: 'Estás ganando comida gratis',
    every_euro_one: 'Cada {{amount}} que gastas = 1 pt. Canjea por artículos gratis y descuentos.',
    every_euro_other: 'Cada {{amount}} que gastas = {{count}} pts. Canjea por artículos gratis y descuentos.',
    until_redeem: '{{remaining}} pts hasta poder canjear',
    unlock_first: '¡Este pedido solo ya desbloquea tu primera recompensa!',
    so_close: '¡Tan cerca de comida gratis!',
    just_more: 'Solo {{remaining}} pts más y podrás empezar a ahorrar.',
    pts_to_unlock: '{{remaining}} pts para desbloquear recompensas',
    this_order_unlocks: 'Este pedido te lleva a {{points}} pts — ¡puedes canjear en el próximo pedido!',
    save_next: 'Ahorra hasta {{amount}} la próxima vez',
    pts_from_order: '+{{earned}} pts de este pedido — ¡solo te quedan {{remaining}}!',
    rewards_value: '= {{amount}} en recompensas',
    save_this_order: 'Ahorra hasta {{amount}} en este pedido',
    use_pts: 'Usa tus {{points}} pts al pagar',
    earned_this_order: '+{{points}} pts ganados en este pedido',
    current: 'Actual',
    from_this_order: '+{{points}} de este pedido',
    expiration_zero: '{{points}} pts vencen hoy',
    expiration_one: '{{points}} pts vencen en 1 día',
    expiration_other: '{{points}} pts vencen en {{count}} días',
  },
};
